import LanguagesPage from './LanguagesPage';

export default LanguagesPage;
